import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { SchoolForm } from "../../components/school/SchoolForm";
import { useYearContext } from "../../hooks/useYearContext";
import { ContentShell } from "../../layout/ContentShell";
import { getSchoolTranslation, type School } from "../../models/school";
import { school_path, schools_path } from "../../routes";

type SchoolEditProps = {
  school: School;
};

export default function SchoolEdit({ school }: SchoolEditProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.patch(pathWithYearContext(school_path, school.id), values);
  return (
    <ContentShell title={`Schule ${getSchoolTranslation(school)} bearbeiten`} onBack={() => router.get(pathWithYearContext(schools_path))}>
      <SchoolForm school={school} submitButtonLabel="Speichern" onSubmit={onSubmit} />
    </ContentShell>
  );
}
